/* External dependencies */
import { gql } from '@apollo/client';

export const getUserQuery = gql`
  query getUser($input: GetUserInput!) {
    getUser(input: $input) {
      id
      email
      firstName
      lastName
      phone
      status
      groupName
      personalNumber
      identificationStatus
      identificationDocument {
        id
        createdDate
        identificationData {
          pin
          documentNumber
          front
          back
          selfie
        }
        updatedDate
      }
    }
  }
`;
